module.exports = "\n\n<router-outlet></router-outlet>\n\n  "